/** Etiqueta de curso incluyendo año para distinguir homónimos. */
export type CursoLabelParts = {
  nombre?: string | null;
  codigo?: string | null;
  anio?: number | string | null;
};

export function formatCursoLabel(
  curso?: CursoLabelParts | null,
  options?: { withCodigo?: boolean },
): string {
  if (!curso) return '—';

  const nombre = (curso.nombre || '').trim();
  const codigo = (curso.codigo || '').trim();
  const anio = curso.anio != null && curso.anio !== '' ? String(curso.anio) : '';
  const withCodigo = options?.withCodigo !== false;

  let label = nombre || codigo || '—';
  if (withCodigo && codigo && codigo !== nombre) {
    label = `${nombre} (${codigo})`;
  } else if (withCodigo && codigo && nombre) {
    label = `${nombre} (${codigo})`;
  }

  if (anio) {
    label = `${label} · ${anio}`;
  }

  return label;
}

/** Nombre principal + año (para títulos / primera línea). */
export function formatCursoNombreAnio(curso?: CursoLabelParts | null): string {
  if (!curso) return '—';
  const nombre = (curso.nombre || '').trim() || '—';
  const anio = curso.anio != null && curso.anio !== '' ? String(curso.anio) : '';
  return anio ? `${nombre} · ${anio}` : nombre;
}
